import { render } from "./UpDownGrade.vue?vue&type=template&id=00d98084"
import script from "./UpDownGrade.vue?vue&type=script&lang=js"
export * from "./UpDownGrade.vue?vue&type=script&lang=js"

import "./UpDownGrade.vue?vue&type=style&index=0&id=00d98084&lang=css"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__